export const TITLES = {
  exhibitionFunnel: 'Purchase Exhibition Tickets',
  components: {
    errorNotificationsToast: 'Oops!',
    eventsDuringVisit: (orgName: string) => `Events at ${orgName} when you visit`,
    newsletter: 'Open your Inbox to New Realms!',
    orderSummary: 'Order Summary',
    locationWithAddress: 'Location',
    membershipPerks: (membershipRole: string) => `${membershipRole}`,
    membershipPerksPassDetails: 'Pass details',
    localChecker: (stateName: string) => `${stateName} residents`,
    giftCard: 'Have a Gift Card?',
    loadingBlob: {
      paymentTitle: 'Processing Payment',
      noPaymentTitle: 'Processing Order',
    },
    modal: { default: 'Please Confirm...' },
  },
  steps: {
    timeSelect: {
      selectDate: 'Select Visit Date',
      entryTime: 'Select Entry Time',
      entryType: 'Select Entry Type',
    },
    orderTickets: 'Select Your Tickets',
    additionalInfo: 'Additional info',
    orderAddOns: 'Select add-ons', // NOTE this is overridden by the event title
    orderAddOnsOptional: 'Optional',
    checkout: 'Checkout',
    checkoutLastStep: 'Last step!',
  },
  collapsedSteps: {
    dateTime: 'Date and Entry Time',
    orderTickets: 'Tickets',
    contactInfo: 'Customer Info',
  },
}
